import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { handleRequestError } from "utils/Request";

export type ShiftDate = {
  date: string;
  type: 'friday' | 'holiday';
};

async function fetchUpcomingDates(): Promise<ShiftDate[]> {
  const { data } = await api.get('/support/shifts/upcoming-dates');
  return data;
}

export function useShiftUpcomingDates() {
  const query = useQuery(['shift-upcoming-dates'], fetchUpcomingDates, {
    staleTime: 1000 * 60 * 60, // 1h
  });

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Erro ao carregar datas de plantão.');
  }, [query.isError, query.error]);

  return query;
}
